<vs-dialog [config]="{ dialogContainerClass: 'max-w-[600px]' }">
  <vs-dialog-header
    class="block mb-6"
    [config]="{
      mode: 'simple',
      showDivider: false,
      hideCloseButton: saving,
      iconTheme: 'danger',
      icon: 'x-circle',
      title: 'Void Warranty',
      subtitle: 'This marks the warranty as void and issues full refunds for eligible payments. Please provide a reason.'
    }"
  ></vs-dialog-header>

  <vs-form-field
    class="mt-4 mb-8"
    [config]="{
      label: { text: 'Void Reason', for: 'void-reason' }
    }"
  >
    <input id="void-reason" vsInput type="text" placeholder="Reason for voiding..." [formControl]="reasonControl" />
  </vs-form-field>

  <div class="flex gap-2">
    <button vs-button appearance="outline" class="flex-1" [disabled]="saving" (click)="close()">Cancel</button>
    <button vs-button theme="danger" class="flex-1" [disabled]="saving || reasonControl.invalid" (click)="submit()">
      Void Warranty
    </button>
  </div>
</vs-dialog>
